module.exports = __webpack_public_path__ + "img/slide-5.a71870b1.png";